import React from 'react';
import {Link} from 'react-router';
import * as config from '~/config';
import {ApiError} from '~/redux/types/common/ServerErrorType';

const {SERVICE_UNAVAILABLE_MESSAGE, CONTACT_US_MESSAGE} = config;

export interface SubmissionErrorProps {
    error: ApiError | null;
    errorStyleClass: string;
}

const SubmissionError: React.FC<SubmissionErrorProps> = ({error, errorStyleClass}) => {
    const responseErrorGroup = error?.code?.toString()?.charAt(0);
    const errorMessage = responseErrorGroup === '5' ? SERVICE_UNAVAILABLE_MESSAGE : error?.message;
    let linkToSupport = null;

    if (errorMessage?.includes(CONTACT_US_MESSAGE)) {
        const [mainPart, ...rest] = errorMessage.split(`${CONTACT_US_MESSAGE}`);
        linkToSupport = (
            <>
                {mainPart}
                <Link to='/support/form'>{CONTACT_US_MESSAGE}</Link>
                {rest.join('')}
            </>
        );
    }

    return <div className={errorStyleClass}>{linkToSupport || errorMessage}</div>;
};

export default SubmissionError;
